import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  select_input: {
    width: "312px",
    margin: "5px 5px 0px 5px",
    [theme.breakpoints.down("1020")]: {
      width: "100%",
    },
    [theme.breakpoints.down("899")]: {
      width: "65%",
    },
    [theme.breakpoints.down("865")]: {
      margin: 5,
    },
  },
}));

const defaultOptions = [
  { name: "Rating", value: "rating" },
  { name: "Title", value: "title" },
  { name: "Votes", value: "votes" },
  { name: "Year", value: "year" },
];

const SortSelect = ({
  sortType,
  onSortChange,
  label = "Sort by",
  options = defaultOptions,
}) => {
  const classes = useStyles();

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={classes.select_input}
    >
      <InputLabel id="sort-select-label">{label}</InputLabel>
      <Select
        labelId="sort-select-label"
        id="sort-select"
        value={sortType}
        onChange={(e) => onSortChange(e.target.value)}
        label={label}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SortSelect;
